import update from 'immutability-helper';
import ActionTypes from 'constants/ActionTypes';

const initialState = {
    app: {
        visibility: false,
    },
    history: {
        visibility: false,
    },
};

const panelsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.UI_PANELS_APP_SHOW: {
            return update(state, {
                app: {
                    visibility: {
                        $set: true,
                    },
                },
            });
        }
        case ActionTypes.UI_PANELS_APP_CLOSE: {
            return update(state, {
                app: {
                    visibility: {
                        $set: false,
                    },
                },
            });
        }
        case ActionTypes.UI_PANELS_HISTORY_SHOW: {
            return update(state, {
                history: {
                    visibility: {
                        $set: true,
                    },
                },
            });
        }
        case ActionTypes.UI_PANELS_HISTORY_CLOSE: {
            return update(state, {
                history: {
                    visibility: {
                        $set: false,
                    },
                },
            });
        }
        case ActionTypes.UI_ALL_CLOSE: {
            return initialState;
        }
        default: {
            return state;
        }
    }
};

export default panelsReducer;
